// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"e78c98f1","213":"2ab6941b","215":"c9564448","295":"e09dab64","349":"e3736061","359":"f3ad6747","453":"fdda853a","455":"94882419","524":"922ae01f","625":"2a93c298","961":"7cfd5f99"}[chunkId] + ".chunk.js";
};